import(/* webpackMode: "eager", webpackExports: ["FinalCtaBanner"] */ "/vercel/path0/src/components/finalCtaBanner/finalCtaBanner.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerTestimonialsFr"] */ "/vercel/path0/src/components/fr/customerTestimonialsFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqFr"] */ "/vercel/path0/src/components/fr/faqFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformHowToFr"] */ "/vercel/path0/src/components/fr/platformHowToFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedWidgetsFr"] */ "/vercel/path0/src/components/fr/relatedWidgetsFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportedPlatformsFr"] */ "/vercel/path0/src/components/fr/supportedPlatformsFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetFeaturesFr"] */ "/vercel/path0/src/components/fr/widgetFeaturesFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetHeroLightFr"] */ "/vercel/path0/src/components/fr/widgetHeroLightFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetLivePlaygroundFr"] */ "/vercel/path0/src/components/fr/widgetLivePlaygroundFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetPlatformCarouselFr"] */ "/vercel/path0/src/components/fr/widgetPlatformCarouselFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetVideoGuideFr"] */ "/vercel/path0/src/components/fr/widgetVideoGuideFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroPlatformPills"] */ "/vercel/path0/src/components/heroPlatformPills/heroPlatformPills.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/vercel/path0/src/components/howItWorks/howItWorks.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HubBenefits"] */ "/vercel/path0/src/components/hubBenefits/hubBenefits.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MidPageCta"] */ "/vercel/path0/src/components/midPageCta/midPageCta.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuickAnswers"] */ "/vercel/path0/src/components/quickAnswers/quickAnswers.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsStrip"] */ "/vercel/path0/src/components/statsStrip/statsStrip.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyMobileCta"] */ "/vercel/path0/src/components/stickyMobileCta/stickyMobileCta.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyUseWidget"] */ "/vercel/path0/src/components/whyUseWidget/whyUseWidget.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetDefinition"] */ "/vercel/path0/src/components/widgetDefinition/widgetDefinition.comp.tsx");
